import { createElement } from 'react';
import { SidebarNavItemWithIcon } from '../schemas/types/shared';
import { ArchiveIcon, IdCardIcon, PersonIcon } from '@radix-ui/react-icons';
import { APP_URLS } from './app-urls';

export const ITEMS_PER_PAGE = 10;
export const NOTES_PER_PAGE = 10;
export const NAVIGATION_ITEMS = [
  {
    label: 'Подписка',
    path: APP_URLS.signUpChoosePlanUrl
  }
];
export const NAV_MENU_SLUGS = ['/', ...NAVIGATION_ITEMS.map(item => item.path)];

export const PERSONAL_SIDEBAR_ITEMS: SidebarNavItemWithIcon[] = [
  {
    label: 'Главная',
    path: '/profile/general',
    commingSoon: false,
    icon: createElement(PersonIcon)
  },
  {
    label: 'Личная информация',
    path: '/profile/personal-info',
    commingSoon: false,
    icon: createElement(IdCardIcon)
  },
  {
    label: 'Подписка',
    path: '/profile/subscription',
    commingSoon: false,
    icon: createElement(ArchiveIcon)
  }
  // {
  //   label: 'Избранное',
  //   path: '/profile/favorites',
  //   commingSoon: true,
  //   icon: createElement(StarIcon)
  // }
];
